<template>
  <div>
    <div>
      <div class="item">
        <span class="title">名称</span>
        <div>
          <el-input v-model="name" style="width:150px" placeholder="请输入名称" />
        </div>
      </div>
      <div class="item">
        <span class="title">类型</span>
        <el-select v-model="type" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="item">
        <span class="title">关键字</span>
        <div style="flex:1">
          <el-tag
            v-for="tag in keyWordsObj"
            :key="tag"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
          >
            {{ tag }}
          </el-tag>
          <el-input
            v-if="inputVisible"
            ref="saveTagInput"
            v-model="inputValue"
            class="input-new-tag"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          />
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新建关键词</el-button>
        </div>
      </div>
      <div v-if="!drawerItem.id" class="item">
        <span class="title" style="width:100px">时间(非必填)</span>
        <div>
          <el-date-picker
            v-model="start_time"
            type="date"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="{
              disabledDate: (time) => {
                return time.getTime() > (Date.now() - 1 * 24* 60 * 60 * 1000)
              }
            }"
          />
        </div>
      </div>
      <div class="item">
        <span class="title">投放组</span>
        <el-autocomplete
          v-model="release_group.value"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(release_group.value = null), (release_group.address = null)"
          @select="handleSelect"
        />
      </div>
      <!-- <div class="item">
        <span class="title">广告主</span>
        <div>
          <el-input v-model="adverIds" style="width:150px" placeholder="请输入广告主" @input="handleParams" />
          <el-button type="primary" style="margin-left:10px" @click="multipleObj">选中多个</el-button>
        </div>
      </div>
      <div class="checkBox">
        <span class="title1">选中的广告主</span>
        <div class="checkBox_content">
          <el-tag
            v-for="item in adverIdsObj"
            :key="item.value"
            size="small"
          >
            {{ item.label }}
            <i
              class="el-icon-close"
              style="font-size: 18px;"
              @click="deleteMultipleObj(item)"
            /></el-tag>
        </div>
      </div> -->
    </div>
    <div style="text-align: end; margin-top:20px">
      <el-button class="" type="primary" @click="determine">确定</el-button>
    </div>
  </div>
</template>

<script>
import { getAdvertiser, getReleaseGroupList } from '@/api/hugeAdvertGroup.js'
export default {
  props: {
    drawerItem: {
      type: Object,
      default() {
        return {

        }
      }
    }
  },
  data() {
    return {
      options: [{
        value: '1',
        label: '头条'
      }, {
        value: '2',
        label: '腾讯'
      }],
      type: null,
      name: null, // 名称
      // adverIds: null, // 广告主
      // adverIdsObj: [], // 渲染广告主tag列表的数组
      // adverIdsValue: [], // 广告主传参的数组
      // fromAdvertiser: [], // 广告主
      start_time: '',
      inputVisible: false,
      inputValue: '', // 输入关键字
      keyWordsObj: [], // 渲染关键字tag列表的数组
      release_group: {
        value: null,
        address: null
      } // 投放组
    }
  },
  created() {
    window.aaa = this
    this.init()
  },
  mounted() {
  },
  methods: {
    // 投放组选搜索
    async querySearchAsync(queryString, cb) {
      const data = await getReleaseGroupList({
        group_name: queryString || null
      })
      cb(data.data.list.map((item) => {
        return {
          value: item.group_name,
          address: item.id
        }
      }))
    },
    // 选中哪一项
    handleSelect(item) {
      this.release_group = item
    },
    handleClose(tag) {
      this.keyWordsObj.splice(this.keyWordsObj.indexOf(tag), 1)
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm() {
      const inputValue = this.inputValue
      if (inputValue) {
        this.keyWordsObj.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },

    // 确定
    determine() {
      if (this.judgmentParameters()) {
        const parameter = {
          name: this.name,
          key_words: this.keyWordsObj,
          group_id: this.release_group.address,
          type: this.type
          // ocean_advertiser_ids: this.adverIdsValue
        }
        this.$emit('determine', parameter, this.start_time)
      }
    },

    // 判断参数
    judgmentParameters() {
      let text = null
      if (!this.name) {
        text = '请填写广告名称'
      } else if (!this.keyWordsObj.length) {
        text = '请添加关键字'
      } else if (!this.release_group.address) {
        text = '请选择投放组'
      } else if (this.type === null) {
        text = '请选择类型'
      }

      text && this.$message({
        message: text,
        type: 'warning'
      })

      return !text
    },

    // 初始化
    init() {
      console.log(this.drawerItem, 'this.drawerItem')
      // 名称
      this.name = this.drawerItem.name ? this.drawerItem.name : null
      this.type = this.drawerItem.type ? String(this.drawerItem.type) : null
      // 关键字
      this.keyWordsObj = this.drawerItem.key_words && this.drawerItem.key_words.length ? this.drawerItem.key_words : []
      this.start_time = this.drawerItem.start_time ? this.drawerItem.start_time : ''
      this.release_group.value = this.drawerItem.group_name ? this.drawerItem.group_name : null
      this.release_group.address = this.drawerItem.group_id ? this.drawerItem.group_id : null
      // this.release_group = this.drawerItem.group_name && {
      //   value: this.drawerItem.group_name,
      //   address: this.drawerItem.group_id
      // }
      // // 广告主
      // this.adverIdsValue = (this.drawerItem.ocean_advertiser_ids && this.drawerItem.ocean_advertiser_ids.length) ? [...this.drawerItem.ocean_advertiser_ids] : []
      // this.fromAdvertiser = this.adverIdsValue.length ? this.drawerItem.ocean_advertiser.map((item, index) => {
      //   return {
      //     value: item.account_id,
      //     label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
      //   }
      // }) : []
      // this.adverIdsObj = this.adverIdsValue.length ? this.drawerItem.ocean_advertiser.map((item, index) => {
      //   return {
      //     value: item.account_id,
      //     label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
      //   }
      // }) : []
    },

    // 选中多个广告主
    async multipleObj() {
      if (!this.adverIds) {
        this.$message({
          message: '必须输入广告主id',
          type: 'warning'
        })
        return
      }
      const data = await getAdvertiser({ name: this.adverIds, type: 2 })
      if (!data.data.list.length) {
        this.$message({
          message: '筛选为0个，没法选中',
          type: 'warning'
        })
      }
      let news = data.data.list.map((item) => {
        return {
          value: item.account_id,
          label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
        }
      })
      // 广告主模块
      this.fromAdvertiser = news
      for (let i = 0; i < news.length; i++) {
        (this.adverIdsValue.indexOf(news[i].value) < 0) && this.adverIdsValue.push(news[i].value)
      }
      news = news.map(im => im.value)
      for (let i = 0; i < this.adverIdsValue.length; i++) {
        news.indexOf(this.adverIdsValue[i]) < 0 && news.push(this.adverIdsValue[i])
      }
      this.changeAdvert(news)
      data.data.list.length && this.judgeThatOneIsNotSelected(this.adverIds, data.data.list, 'account_id')
      this.adverIds = null
    },
    // 选择广告主
    changeAdvert(item) {
      console.log(this.adverIdsValue)
      for (let i = 0; i < this.adverIdsValue.length; i++) {
        const im = this.adverIdsValue[i]
        const index = this.adverIdsObj.findIndex(itemm => itemm.value === im)
        index < 0 && this.adverIdsObj.push({ value: im, label: this.fromAdvertiser[this.fromAdvertiser.findIndex(itemm => itemm.value === im)].label })
      }
      this.adverIdsObj = this.adverIdsObj.filter((imm) => {
        return !(item.indexOf(imm.value) < 0)
      })
    },
    // 判断那个没选中
    judgeThatOneIsNotSelected(texts, arr, idName) {
      const testsr = texts.split(',')
      const unchecked = []
      testsr.forEach((text) => {
        let bool = true
        for (let i = 0; i < arr.length; i++) {
          if (String(arr[i][idName]) === String(text) || String(arr[i].account_name) === String(text)) {
            bool = false
            break
          }
        }
        bool && unchecked.push(text)
      })

      unchecked.length && this.$message({
        message: unchecked.join() + '  没被选中',
        type: 'warning'
      })
    },

    // 删除选项
    deleteMultipleObj(item) {
      this.adverIdsObj.splice(this.adverIdsObj.findIndex(im => im.value === item.value), 1)
      this.adverIdsValue.splice(this.adverIdsValue.indexOf(item.value), 1)
    },
    handleParams(value) {
      const str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、 ]/img
      this.adverIds = value.replace(str, ',')
      const str1 = /(,){1,}/img
      this.adverIds = this.adverIds.replace(str1, ',')
    },

    // 创建渲染回填时想要的结构数据
    createTheDesiredStructure(isL) {
      this.type = null
      this.name = null
      this.release_group = { value: null, address: null }
      this.start_time = null
      const obj = !isL ? {
        name: this.name,
        key_words: this.keyWordsObj,
        start_time: this.start_time,
        group_name: this.release_group.value ? this.release_group.value : null,
        group_id: this.release_group.address ? this.release_group.address : null
        // 巨量广告
        // ocean_advertiser_ids: (this.adverIdsValue && this.adverIdsValue.length) ? this.adverIdsValue : [],
        // ocean_advertiser: (this.adverIdsObj && this.adverIdsObj.length) ? this.adverIdsObj.map((item) => {
        //   const s = item.label.split('--')
        //   return {
        //     account_id: item.value,
        //     account_name: s[0],
        //     agent_name: s[s.length - 1]
        //   }
        // }) : []
      } : {}
      return obj
    }

  }
}
</script>

<style scoped>
.item{
   display: flex;
   align-items: center;
   margin-bottom: 20px;
}

.item .title{
    width: 55px;
}
.item .title1{
    width: 100px;
}

.checkBox{
   margin-bottom: 26px;
}

.checkBox_title{
}

.checkBox_content{

}

.content_item{

}
.el-tag--medium {
  margin: 10px 10px 0 0 !important;
}
.el-tag--small {
  margin-top: 8px !important;
}

.button-new-tag {
  margin: 10px 10px 0 0;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin: 10px 10px 0 10px;
  vertical-align: bottom;
}
</style>
